<mat-card>
  <div class="header-content">
    <a class="navbar-brand" matTooltip="Startseite" routerLink="/">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 205 110" height="48" role="img" aria-label="aSchwartz Logo">
        <!-- A-Element -->
        <g transform="translate(0,10)">
          <rect x="0" y="0" width="90" height="90" rx="6" ry="6" fill="none" stroke="#3c9df3" stroke-width="3" />
          <text x="10" y="22" fill="#3c9df3" font-family="Inter, Roboto, Arial, sans-serif" font-size="14" font-weight="600">1</text>
          <text
            x="45"
            y="62"
            text-anchor="middle"
            fill="#3c9df3"
            font-family="Inter, Roboto, Arial, sans-serif"
            font-size="48"
            font-weight="700">
            A
          </text>
        </g>

        <!-- S-Element -->
        <g transform="translate(110,10)">
          <rect x="0" y="0" width="90" height="90" rx="6" ry="6" fill="none" stroke="#3c9df3" stroke-width="3" />
          <text x="62" y="22" fill="#3c9df3" font-family="Inter, Roboto, Arial, sans-serif" font-size="14" font-weight="600">16</text>
          <text
            x="45"
            y="62"
            text-anchor="middle"
            fill="#3c9df3"
            font-family="Inter, Roboto, Arial, sans-serif"
            font-size="48"
            font-weight="700">
            S
          </text>
        </g>
      </svg>
    </a>

    <button
      type="button"
      mat-button
      class="nav-link-btn d-none d-xxs-block hover-background"
      routerLink="/software-development"
      routerLinkActive="active">
      Software-Entwicklung
    </button>
    <button
      type="button"
      mat-button
      class="nav-link-btn d-none d-xs-block hover-background"
      routerLink="/trump-post-alert"
      routerLinkActive="active">
      Trump Post Alert
    </button>
    <button
      type="button"
      mat-button
      class="nav-link-btn d-none d-sm-block hover-background"
      routerLink="/blitzshare"
      routerLinkActive="active">
      Blitzshare
    </button>
    <button
      type="button"
      mat-button
      class="nav-link-btn d-none d-md-block hover-background"
      routerLink="/real-estate"
      routerLinkActive="active">
      Immobilien
    </button>
    <button
      type="button"
      mat-button
      class="nav-link-btn d-none d-xl-block hover-background"
      routerLink="/photography"
      routerLinkActive="active">
      Fotografie
    </button>

    <mat-menu #menu="matMenu">
      <a mat-menu-item routerLink="/software-development" routerLinkActive="menu-active">Software Entwicklung</a>
      <a mat-menu-item routerLink="/trump-post-alert" routerLinkActive="menu-active">Trump Post Alert</a>
      <a mat-menu-item routerLink="/blitzshare" routerLinkActive="menu-active">Blitzshare</a>
      <a mat-menu-item routerLink="/real-estate" routerLinkActive="menu-active">Immobilien</a>
      <a mat-menu-item routerLink="/photography" routerLinkActive="menu-active">Fotografie</a>
    </mat-menu>

    <div class="name-email-image-container">
      <div class="d-none d-lg-block name-email-container">
        <a class="name p-0 m-0" matTooltip="Kontakt" routerLink="./contact">Alexander Schwartz<br /></a>
        <a class="email p-0 m-0" href="mailto:{{ contactMail }}" matTooltip="Email senden">{{ contactMail }}</a>
      </div>

      <a matTooltip="Kontakt" routerLink="./contact" class="d-none d-lg-block"
        ><img alt="Bild von Alexander Schwartz" class="avatar ml-2" ngSrc="./assets/images/header-avatar.webp" height="60" width="69"
      /></a>
    </div>

    <button [matMenuTriggerFor]="menu" aria-label="Menu" class="d-block d-xl-none menu-button" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>
</mat-card>
